import { FeatureRegistry } from './FeatureRegistry';

export function createFeatureRegistry(): FeatureRegistry {
  return new FeatureRegistry();
}
